import type { EntryQuery } from '@thom/folio-domain/core/ports/entries'
import type { ChangeSignal } from '@thom/folio-domain/core/ports/live'
import { Collections } from '@thom/folio-ui/pocketbase-types'
import { columns } from './entries-adapter'
import type { Realtime } from './realtime'

const createEntrySignal = ({ client, connection }: Realtime): ChangeSignal<EntryQuery> => ({
	source: { client, collection: Collections.JournEntries, map: record => record, connection },
	options: ({ project, filter }) => ({ filter: columns(project, filter), sort: '-updated', perPage: 1 }),
})

export { createEntrySignal }
